// extracted by mini-css-extract-plugin
export var component = "Breadcrumbs-module--component--jY6S7";
export var description = "Breadcrumbs-module--description--J-X8a";
export var list = "Breadcrumbs-module--list---6ARD";
export var item = "Breadcrumbs-module--item--qMlCw";
export var separator = "Breadcrumbs-module--separator--5EfoG";
export var link = "Breadcrumbs-module--link--pf4Op";
export var sronly = "Breadcrumbs-module--sronly--QOOGC";